<div fxLayout="column" fxLayoutGap="10px">
  <h2 class="page-header left">OTDS Proceso de Errores</h2>
  <mat-tab-group>
    <mat-tab label="Errores">
      <ng-template matTabContent>
        <app-otds-error-processing></app-otds-error-processing>
      </ng-template>
    </mat-tab>
    <mat-tab label="Logs">
      <ng-template matTabContent>
        <app-otds-error-log></app-otds-error-log>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
